// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = require("../../../../html-loader/dist/runtime/getUrl.js");
var ___HTML_LOADER_IMPORT_0___ = require("./ajax-loader.gif");
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var code = "<div class=\"was-this-useful__loading\"> <img class=\"was-this-useful__loading__image\" src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\" alt=\"Was this useful loader\"/> </div>";
// Exports
module.exports = code;